import script from "./record-all-selections-button.vue?vue&type=script&lang=js"
export * from "./record-all-selections-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__